import PageContentWrapper from '../layout/PageContentWrapper'
import StyledAdditionalNotifyMethod from './StyledAdditionalNotifyMethod'

const StyledConfiguration = () => {
    return (
        <PageContentWrapper className={'p-4'}>
            <div className="" style={{minHeight: 'calc(100vh - 8rem)'}}>
                <h3 className="pt-2 mb-0 font-bold text-3xl md:text-4xl text-teal-700">
                    Emergency Support Configuration
                </h3>
                <p className="text-700 text-md font-normal">
                    The process of setting up emergency support configuration
                    and options to ensure it operates according to predefined
                    requirements.
                </p>
                <hr />

                <StyledAdditionalNotifyMethod />
            </div>
        </PageContentWrapper>
    )
}

export default StyledConfiguration
